import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GroundControlPointState } from '../store.states';
import { groundControlPointsAdapter } from './gcp.reducer';

export const selectGroundControlPointState =
  createFeatureSelector<GroundControlPointState>('groundControlPoints');

export const selectGroundControlPoint = createSelector(
  selectGroundControlPointState,
  (state) => ({
    ...state,
  }),
);

export const selectGroundControlPoints = createSelector(
  selectGroundControlPoint,
  (state) => state.groundControlPoints,
);

export const {
  selectAll: selectAllGroundControlPoints,
  selectEntities: selectGroundControlPointEntities,
  selectIds: selectGroundControlPointIds,
  selectTotal: selectTotalGroundControlPoints,
} = groundControlPointsAdapter.getSelectors(selectGroundControlPoints);

// Selector to fetch a specific GCP by ID
export const selectGroundControlPointById = (id: string) =>
  createSelector(selectGroundControlPointEntities, (entities) => entities[id]);
